import { PostOptionsModalType } from "./ReactionsListModal.types";
import {
    getPostReactions,
    getPostSpecificTypeReactions,
} from "./ReactionsListService";
import { EntityReactionsListModal } from "./EntityReactionsListModal";

export function PostReactionsListModal(props: PostOptionsModalType) {
    return (
        <EntityReactionsListModal
            itemId={props.postId}
            initialfetcher={getPostReactions}
            mainFetcher={getPostSpecificTypeReactions}
            {...props}
        />
    );
}
